<template>
    <site-img
        class="md-team double-column-short-intro"
        type="bgImg"
        :src="bgType === 'img' ? useBgSrc : ''"
        :style="{
            backgroundColor: bgType === 'color' ? bgColor : '',
            paddingTop,
            marginBottom
        }"
        v-if="allTotal > 0"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <div class="mg-title" v-if="fmtTitle" v-html="formatFontSize(fmtTitle, '--mg-title-size')"></div>
            <div class="agent-container">
                <div class="agent-item" v-for="agent in agents" :key="agent.id">
                    <div class="agent-image">
                        <a
                            :href="useExternalUrl ? agent.externalUrl || agent.detailUrl : agent.detailUrl"
                            :target="detailUrlTarget"
                            rel="noopener noreferrer"
                            :aria-label="agentAlt(agent)"
                        >
                            <AgentHeadShot class="agent-img" :headshots="agent.headShots" :initImage="agent.image" :alt="agentAlt(agent)" keyClass="md-team-double-column-short-intro"></AgentHeadShot>
                        </a>
                    </div>
                    <div class="agent-info-name agent-info">
                        <a
                            :href="agent.detailUrl"
                            :target="detailUrlTarget"
                            rel="noopener noreferrer"
                        >
                            <p
                                class="agent-name info-item"
                                v-if="!!agent.fullName"
                            >
                                {{ agent.fullName }}
                            </p>
                        </a>
                        <p
                            class="agent-position info-item"
                            v-if="
                                agent.license ||
                                    agent.licenseWithState ||
                                    agent.position
                            "
                        >
                            <span class="agent-pos" v-if="!!agent.position">{{
                                agent.position
                            }}</span>
                            <span
                                class="line"
                                v-if="
                                    (agent.license || agent.licenseWithState) &&
                                        agent.position
                                "
                            >|</span
                            >
                            <span
                                class="agent-les"
                                v-if="
                                    !!agent.licenseWithState || !!agent.license
                                "
                            >
                                {{ licenseName }}
                                {{
                                    agent.licenseWithState || agent.license
                                }}</span
                            >
                        </p>
                    </div>
                    <p class="agent-line"></p>
                    <div class="agent-info-contact agent-info">
                        <a
                            v-if="!!agent.phone"
                            class="info-item agent-phone"
                            :href="'tel:' + agent.phone"
                            target="_top"
                            rel="noopener noreferrer"
                        >
                            <span class="iconfont icon-telephone"></span>
                            <span class="text">{{
                                $ft.formatPhone(agent.phone)
                            }}</span>
                        </a>
                        <a
                            v-if="!!agent.email"
                            class="agent-email info-item"
                            :href="'mailto:' + agent.email"
                            target="_top"
                            rel="noopener noreferrer"
                        >
                            <span class="iconfont icon-email"></span>
                            <span class="text">{{ agent.email }}</span>
                        </a>
                        <a
                            v-if="!!agent.externalUrl"
                            class="agent-website info-item"
                            :href="agent.externalUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <span class="iconfont icon-company"></span>
                            <span class="text">{{ agent.externalUrl }}</span>
                        </a>
                        <p
                            class="agent-info-line"
                            v-if="!!agent.longIntroduction"
                        ></p>
                        <div class="agent-intro" v-if="agent.longIntroduction && !isMobileSize" v-html="agent.longIntroduction"></div>
                        <viewMore
                            class="view-more-content"
                            v-if="agent.longIntroduction && isMobileSize"
                            :line="2"
                            :content="agent.longIntroduction"
                            :mobileLine="6"
                        />
                    </div>
                </div>
            </div>
            <pagination
                v-if="total > 1"
                :totalPage="total"
                @pageChange="pageChange"
                :pageSize="pageSize"
                :noScroll="true"
                :pageNum="pageNum"
            ></pagination>
        </module-box>
    </site-img>
</template>

<script>
import common from '../index';
import { normal } from '../../defaultSpacing';
import viewMore from '../../../components/view-more.vue';
export default {
    data: function() {
        return {
            ...normal
        };
    },
    components: {
        viewMore
    },
    computed: {
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        }
    },
    mixins: [common]
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-team.double-column-short-intro {
    .agent-container {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .agent-item {
            width: calc(50% - 10px);
            margin-bottom: 20px;
            background-color: #fff;
            height: 210px;
            position: relative;
            .agent-image {
                position: absolute;
                left: 0;
                top: 0;
                width: 200px;
                height: 210px;
                overflow: hidden;
                .agent-img {
                    width: 100%;
                    height: 100%;
                }
            }
            .agent-line {
                margin: 15px 0;
                border-top: 1px solid #ebecf1;
                width: calc(100% - 250px);
                margin-left: 230px;
            }
            .agent-info {
                padding: 0 20px;
                margin-left: 210px;
                width: calc(100% - 210px);
                &.agent-info-name {
                    height: 49px;
                    padding-top: 3px;
                }
                &.agent-info-contact {
                    padding-bottom: 8px;
                }
                .info-item {
                    @include ellipsis();
                    display: block;
                    color: var(--color-info);
                    font-size: 14px;
                    height: 20px;
                    line-height: 20px;
                    margin-bottom: 6px;
                    .iconfont {
                        vertical-align: middle;
                        font-size: 12px;
                        margin-left: 1px;
                        margin-right: 5px;
                        &.icon-telephone,
                        &.icon-company {
                            font-size: 13px;
                        }
                    }
                    &.agent-name {
                        color: var(--color-text);
                        font-size: 20px;
                        font-family: var(--font-bold);
                        line-height: 22px;
                    }
                    &.agent-position {
                        line-height: 15px;
                        margin-bottom: 0;
                        .line {
                            padding: 0 2px;
                        }
                    }
                }
                .agent-intro {
                    position: absolute;
                    bottom: 0;
                    left: 230px;
                    color: var(--color-info);
                    font-size: 14px;
                    margin-top: 6px;
                    @include webkitBox(2);
                }
            }
            .view-more-content {
                color: #797e8b;
                font-size: 14px;
                line-height: 24px;
                &:last-of-type {
                    padding-bottom: 0;
                }
            }
        }
    }
    @include media-800 {
        .agent-container .agent-item {
            width: 100%;
        }
    }
    @include media-600 {
        .agent-container .agent-item {
            height: auto;
            min-height: 52px;
            .agent-image {
                width: 52px;
                height: 52px;
            }
            .agent-line {
                width: 100%;
                margin-left: 0;
                margin-top: 20px;
            }
            .agent-info {
                width: calc(100% - 52px);
                padding-right: 0;
                margin-left: 52px;
                .agent-info-line {
                    border-top: solid 1px #ebecf1;
                    margin: 9px 0;
                }
                &.agent-info-name {
                    height: 52px;
                }
                &.agent-info-contact {
                    margin-left: 0;
                    padding-left: 0;
                    width: 100%;
                    .agent-intro {
                        @include webkitBox(4);
                    }
                }
            }
        }
    }
    .comp-pagination {
        margin-bottom: 20px;
    }
}
</style>
